import { resolveDeviceMethods } from './device-methods.js';
import { fundingMethodPolicy } from './manifest-policy.js';
import { isGeographyAllowed, isHostedFundingMethod } from './policy.js';
export function returningMethodIssue(previous, eligible, diagnostic) {
    if (!previous || eligible.includes(previous))
        return null;
    return {
        method: previous,
        reason: !diagnostic.connected
            ? 'disconnected'
            : !diagnostic.deviceSupported
                ? 'device_unavailable'
                : !diagnostic.geographyAllowed
                    ? 'region_unavailable'
                    : 'method_unavailable',
    };
}
export function unavailablePreference(discovery, deviceMethods, manifest) {
    const previous = discovery.context.lastMethod;
    if (!previous)
        return null;
    return returningMethodIssue(previous, discovery.methods, {
        connected: discovery.status !== 'connectionRequired',
        deviceSupported: isHostedFundingMethod(previous) ||
            resolveDeviceMethods(deviceMethods, discovery.context.environment).includes(previous),
        geographyAllowed: isGeographyAllowed(fundingMethodPolicy(manifest, previous).geography, discovery.context.country, discovery.context.subdivision),
    });
}
